import en from "@/components/language/locales/en.json";
import id from "@/components/language/locales/id.json";
import zh_TW from "@/components/language/locales/zh_TW.json";
import zh_CN from "@/components/language/locales/zh_CN.json";

export type Locale = "en" | "id" | "zh_CN" | "zh_TW";

const messages = {
  en,
  id,
  zh_TW,
  zh_CN,
};

export const getMessages = (locale: Locale) => {
  return messages[locale] || messages.en;
};
